import ColorFeature from './ColorFeature'
import SizeFeature from './SizeFeature'
import VoltageFeature from './VoltageFeature'
import DefaultFeature from './DefaultFeature'

const features = {
  COR: ColorFeature,
  TAMANHO: SizeFeature,
  VOLTAGEM: VoltageFeature,
  DEFAULT: DefaultFeature
}

const FeatureContainer = ({ type, ...props }) => {
  return features[type]
    ? features[type]({ ...props })
    : features['DEFAULT']({ ...props })
}

export default FeatureContainer



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/index.js